// ========== BOTTLE + DROPLET ANIMATION ==========
function initAnimations() {
  // Reset previous ScrollTriggers
  ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  gsap.killTweensOf("*");

  const isMobile = window.innerWidth < 1240;

  // ===============================
  // ✅ PIXEL PERFECT BOTTLE FILL
  // ===============================
  const bottle = document.querySelector('.water-wrapper-bottom');
  const water = document.querySelector('.bottle-water');

  if (bottle && water) {

    // Wait until image is loaded
    if (!bottle.complete) {
      bottle.onload = () => initAnimations();
    } else {

      let bottleHeight = bottle.offsetHeight;

      // 👉 Adjust this value if needed (0.72 - 0.78 best range)
      let finalHeight = bottleHeight * 0.75;

      gsap.set(water, { height: 0 });

      gsap.to(water, {
        height: finalHeight + 'px',
        scrollTrigger: {
          trigger: '.animated-water',
          start: 'top center',
          end: 'bottom center',
          scrub: 0.3,
          markers: false,
        },
      });
    }
  }

  // ===============================
  // PIN SECTION
  // ===============================
ScrollTrigger.create({
  trigger: '.features',
  start: 'top top',
  end: 'bottom bottom',
  pin: '.animation-wrap',
  pinSpacing: false, // 👈 important change
  invalidateOnRefresh: true
});



  // ===============================
  // FEATURES ANIMATION
  // ===============================
  const featureImgs = gsap.utils.toArray('.feature__img-wrapper .img-overlay');
  const featureBoxes = document.querySelectorAll('.feature__info');
  const featureBoxes_2 = document.querySelectorAll('.feature__info_2');
  const featureBoxes_mobile = document.querySelectorAll('.feature__info_mobile');

  featureImgs.forEach((img, i) => {
    const featureBox = featureBoxes[i];
    const featureBox2 = featureBoxes_2[i];
    const featureBoxMobile = featureBoxes_mobile[i];

    if (featureBox) {
      ScrollTrigger.create({
        trigger: img,
        toggleClass: { targets: featureBox, className: 'active' },
        start: 'top 50%',
        end: 'bottom 50%',
      });
    }

    if (featureBox2) {
      ScrollTrigger.create({
        trigger: img,
        toggleClass: { targets: featureBox2, className: 'active' },
        start: 'top 50%',
        end: 'bottom 50%',
      });
    }

   if (featureBoxMobile) {
        ScrollTrigger.create({
          trigger: img,
          start: 'top 80%',
          end: 'bottom 20%',

          onEnter: () => {
            gsap.set('.feature__info_mobile', { autoAlpha: 0 });
            gsap.set(featureBoxMobile, { autoAlpha: 1 });
          },

          onEnterBack: () => {
            gsap.set('.feature__info_mobile', { autoAlpha: 0 });
            gsap.set(featureBoxMobile, { autoAlpha: 1 });
          }
        });
      }

    // Animations
    if (featureBox) {
      gsap.timeline({
        scrollTrigger: {
          trigger: img,
          start: 'top 70%',
          end: 'bottom 70%',
          toggleActions: 'play reverse play reverse',
        },
      }).from(featureBox, {
        autoAlpha: 0,
        y: 20,
        delay: 0.3,
        duration: 0.3,
      });
    }

    if (featureBox2) {
      gsap.timeline({
        scrollTrigger: {
          trigger: img,
          start: 'top 70%',
          end: 'bottom 70%',
          toggleActions: 'play reverse play reverse',
        },
      }).from(featureBox2, {
        autoAlpha: 0,
        y: 20,
        delay: 0.4,
        duration: 0.3,
      });
    }

    
  });

  // ===============================
  // DROPLET ANIMATION
  // ===============================
  gsap.to(".droplet", {
    y: 500,
    opacity: 1,
    scrollTrigger: {
      trigger: ".animated-water",
      start: "top 70%",
      end: "bottom 60%",
      scrub: 1,
    },
  });

  ScrollTrigger.refresh();
}

// ========== INITIAL LOAD ==========
document.addEventListener("DOMContentLoaded", initAnimations);

// ========== ON RESIZE ==========
let resizeTimer;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    initAnimations();
  }, 400);
});